import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomeShowcase from '../components/HomeShowcase';
import DealerListGrouped from '../components/DealerListGrouped';
import axios from 'axios';
import axiosInstance from '../services/axiosInstance';
import { Box } from '@mui/material';

interface DealerPageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const DealerPage = ({ mode, setMode }: DealerPageProps) => {
  const [isLoggedIn, setLoggedin] = useState<boolean>(false);
  const [dealerData, setDealerData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const payload = {
    dealerCompanyData: true,
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(
          "/CustomerVehicle/VehicleMultipleDataList",
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        const result = response.data as {
          responseCode: string;
          responseMessage?: string;
          responseData?: { dealerCompanyData?: any[] };
        };

        if (result.responseCode === "00" && result.responseData) {
          setDealerData(result.responseData.dealerCompanyData || []);
          // console.log("dealer", result.responseData.dealerCompanyData);
        } else {
          console.error(result.responseMessage || "Failed to fetch dealer data");
        }
      } catch {
        console.error("Error fetching dealer data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  return (
    <>
      <Header />
      <Box
        sx={{
          py: { xs: 10, sm: 14 },
          textAlign: 'center',
        }}
      >
        <DealerListGrouped dealerData={dealerData} />
      </Box>

      <Footer />
    </>
  );
};

export default DealerPage;
